export const LOGIN = 'LOGIN';

export const UPDATE_TOKEN = 'UPDATE_TOKEN';
